module.exports = __webpack_public_path__ + "img/sa.svg";